import { SheetOrDialog } from '@sravni/cosago-react-library/lib/components';
import { Button } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { useBoolean } from '@sravni/react-utils';

import { getAnalyticFromSummaries } from 'shared/lib/getAnalyticFromSummaries';
import { sendEventApplyForLoan, sendEventCancelSelection } from 'shared/lib/sendGAEvents';
import type { TOffer } from 'shared/types/TRankingService';

// TODO разобраться со структурой (feature / entity)
// eslint-disable-next-line boundaries/element-types
import { MfoFullDealForm } from 'features/MfoFullDealForm';
import { useSendOffer } from 'features/OfferControls/lib';

import { TEXTS } from './MfoFullDealButton.texts';

type Props = {
  offer: TOffer;
  buttonProps?: ButtonProps;
};

export const MfoFullDealButton = ({ offer, buttonProps }: Props) => {
  const { onClick: onClickProp, ...otherButtonProps } = buttonProps || {};
  const [isPopupOpen, setIsPopupOpen] = useBoolean();
  const { sendReferralOffer } = useSendOffer('MfoFullDeal');
  const { amount, term, additionalValue } = getAnalyticFromSummaries(offer.summaries);

  const onClick = () => {
    sendEventApplyForLoan({ mfoName: offer?.bankName, amount, term, rate: additionalValue });
    setIsPopupOpen.on();
  };

  const onClose = () => {
    sendEventCancelSelection({ amount, term, rate: additionalValue });
    setIsPopupOpen.off();
  };

  return (
    <>
      <Button
        {...otherButtonProps}
        variant="primary"
        onClick={(event) => {
          event.stopPropagation();
          onClick();
          onClickProp?.(event);
        }}
        loading={isPopupOpen}
      >
        {offer?.additionalInfo?.buttonText || TEXTS.button}
      </Button>
      <SheetOrDialog
        visible={isPopupOpen}
        onClose={onClose}
      >
        <SheetOrDialog.Header title={TEXTS.title} />
        <SheetOrDialog.Content>
          <MfoFullDealForm
            offer={offer}
            onClose={setIsPopupOpen.off}
            sendReferralOffer={sendReferralOffer}
          />
        </SheetOrDialog.Content>
      </SheetOrDialog>
    </>
  );
};
